import { useContext, useEffect } from "react";
import GeneralContext from "../context/GeneralContext";
import { useNavigate } from "react-router-dom";
import FullscreenContainer from "../components/shared/FullscreenContainer";
import Card from "../components/shared/Card";
import ButtonLink from "../components/shared/ButtonLink";
import ButtonFunction from "../components/shared/ButtonFunction";

function AdminUser() {

  const { redirect, logout } = useContext(GeneralContext);

  const navigate = useNavigate();

  useEffect(() => {
    const redirectFunction = async () => {
      const redirectResponse = await redirect('admin');
      if (!redirectResponse.success) {navigate('/')};
    }
    redirectFunction();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const logoutFunction = () => {
    logout();
    navigate('/');
  }

  return (
    <FullscreenContainer>
      <Card delayTime='1'>
        <h1>Elija su ruta de ingreso</h1>
        <ButtonLink buttonClass='loginButton' redirect='/admin-console'>Consola de Administración</ButtonLink>
        <br />
        <br />
        <ButtonLink buttonClass='loginButton' redirect='/normal-user'>Modo Usuario</ButtonLink>
        <br />
        <br />
        <ButtonFunction buttonClass='loginButton' buttonFunction={logoutFunction}>Cerrar Sesión</ButtonFunction>
      </Card>
    </FullscreenContainer>
  )
}

export default AdminUser